import dayjs from 'dayjs';
import { CALENDAR_PALETTE } from './constants';

export const ICONS = {
  huddle: '/assets/huddle-icon.svg',
  google: '/assets/Google Meet.svg',
  zoom: '/assets/Zoom.svg',
  microsoft: '/assets/microsoft-logo.svg',
};

export const getCalendarOptions = (accounts: any) => {
  const options = [
    {
      title: 'Huddle',
      icon: ICONS.huddle,
      type: 'huddle',
      optionName: 'huddle:',
      value: 'huddle',
      color: CALENDAR_PALETTE[0],
    },
  ];

  if (accounts?.googleAccounts?.length) {
    accounts.googleAccounts.forEach((acc: any) => {
      options.push({
        title: acc.email,
        icon: ICONS.google,
        type: 'google',
        optionName: `google:${acc.email}`,
        value: acc?.calendarName || acc.email,
        color: acc?.color || CALENDAR_PALETTE[0],
      });
    });
  }

  if (accounts?.zoomAccounts?.length) {
    accounts.zoomAccounts.forEach((acc: any) => {
      options.push({
        title: acc.email,
        icon: ICONS.zoom,
        type: 'zoom',
        optionName: `zoom:${acc.email}`,
        value: acc?.calendarName || acc.email,
        color: acc?.color || CALENDAR_PALETTE[0],
      });
    });
  }

  if (accounts?.msTeamsAccounts?.length) {
    accounts.msTeamsAccounts.forEach((acc: any) => {
      options.push({
        title: acc.email,
        icon: ICONS.microsoft,
        type: 'microsoft',
        optionName: `microsoft:${acc.email}`,
        value: acc?.calendarName || acc.email,
        color: acc?.color || CALENDAR_PALETTE[0],
      });
    });
  }

  return options;
};

export const timeOptions = () => {
  const times = [];
  let current = dayjs().startOf('day');
  const end = dayjs().endOf('day');

  while (current.isBefore(end)) {
    times.push(current.format('h:mm a'));
    current = current.add(30, 'minutes');
  }
  return times;
};
